import "./index.scss";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityIconOff from "@mui/icons-material/VisibilityOff";
import { Box } from "@mui/material";
import { useState } from "react";

const LabelWithValue = ({
  label,
  value,
  enableViewMode,
}: {
  label: string;
  value: string;
  enableViewMode?: boolean;
}) => {
  const [entryVisible, setEntryVisible] = useState(false);
  return (
    <Box width={"100%"} display="flex" flexDirection="row" gap={"10px"}>
      <p className="label-with-value__label">{label} </p>
      <Box flex={4} display="flex" flexDirection="row" justifyContent="space-between">
        {!enableViewMode && <p className="label-with-value__value">{value}</p>}
        {enableViewMode && (
          <>
            <p className="label-with-value__value">{entryVisible ? value : "***"}</p>
            {!entryVisible && (
              <VisibilityIcon
                className="visibility-icon"
                onClick={() => setEntryVisible(!entryVisible)}
              />
            )}
            {entryVisible && (
              <VisibilityIconOff
                className="visibility-icon"
                onClick={() => setEntryVisible(!entryVisible)}
              />
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default LabelWithValue;
